import React from "react";
import { APP_CONFIG } from "../../constants/constants";

interface DirectionsPanelProps {
  directionsRenderer: google.maps.DirectionsRenderer | null;
  onClose?: () => void;
  isMapCollapsed?: boolean;
}

const DirectionsPanel: React.FC<DirectionsPanelProps> = ({
  directionsRenderer,
  onClose,
  isMapCollapsed = false,
}) => {
  const directionsPanelRef = React.useRef<HTMLDivElement>(null);
  const [isMinimized, setIsMinimized] = React.useState(false);

  React.useEffect(() => {
    if (directionsRenderer && directionsPanelRef.current && !isMinimized) {
      directionsRenderer.setPanel(directionsPanelRef.current);
    } else if (directionsRenderer && isMinimized) {
      directionsRenderer.setPanel(null);
    }
  }, [directionsRenderer, isMinimized]);

  const handleClose = () => {
    if (directionsRenderer) {
      directionsRenderer.setPanel(null);
      directionsRenderer.setDirections({ routes: [] } as any);
      directionsRenderer.setMap(null);
    }
    onClose?.();
  };

  const toggleMinimize = () => {
    setIsMinimized(!isMinimized);
  };

  if (!directionsRenderer) return null;

  return (
    <div
      className={`absolute left-4 transition-all duration-300 ${
        isMapCollapsed
          ? "top-1 max-h-[calc(100%-62px)]"
          : "top-16 max-h-[calc(100%-132px)]"
      } z-[${APP_CONFIG.MAPS.DIRECTIONS_PANEL}] flex flex-col mt-14`}
    >
      <div
        className={`bg-white shadow-lg rounded-md w-80 overflow-hidden flex flex-col ${
          // isMinimized ? "" : "Xh-80 max-h-[calc(100vh-240px)]"
          isMinimized ? "" : "max-h-full"
        }`}
      >
        {/* Header with close and minimize buttons */}
        <div className="flex items-center justify-between p-3 border-b flex-shrink-0">
          <h3 className="text-sm font-semibold text-gray-700">Directions</h3>
          <div className="flex items-center space-x-2">
            {/* Minimize Button */}
            <button
              onClick={toggleMinimize}
              className="text-gray-500 hover:text-gray-700 text-xl leading-none font-bold"
              type="button"
              title={isMinimized ? "Expand" : "Minimize"}
            >
              {isMinimized ? "□" : "−"}
            </button>
            {/* Close Button */}
            <button
              onClick={handleClose}
              className="text-gray-500 hover:text-gray-700 text-xl leading-none"
              type="button"
              title="Close"
            >
              ×
            </button>
          </div>
        </div>

        {/* Directions content - hidden when minimized */}
        {!isMinimized && (
          <div
            ref={directionsPanelRef}
            className="p-3 overflow-y-auto text-sm flex-1 min-h-0"
          />
        )}
      </div>
    </div>
  );
};

export default DirectionsPanel;
